import React from 'react';
import {
  CircularProgress,
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from '@mui/material';
import { Box } from '@mui/system';
import clsx from 'clsx';
import { CustomIcon } from 'components/CustomIcon';
import { IconType } from 'components/CustomIcon/CustomIcon.config';

export interface ButtonProps extends Omit<MuiButtonProps, 'css'> {
  underlined?: boolean;
  label?: string;
  startIcon?: IconType;
  startIconSize?: number;
  endIcon?: IconType;
  endIconSize?: number;
  dense?: boolean;
  iconDense?: boolean;
  isStartIconCircularProgress?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { iconDense, dense, isStartIconCircularProgress = false, ...props },
    ref,
  ) => {
    return (
      <MuiButton
        {...props}
        ref={ref}
        startIcon={
          isStartIconCircularProgress ? (
            <Box mr="8px" display="flex" alignItems="center">
              <CircularProgress color="secondary" size={'20px'} />
            </Box>
          ) : (
            props.startIcon != null && (
              <CustomIcon
                dense={iconDense}
                name={props.startIcon}
                size={props.startIconSize || 1.2}
              />
            )
          )
        }
        endIcon={
          props.endIcon != null && (
            <CustomIcon
              dense={iconDense}
              name={props.endIcon}
              size={props.endIconSize || 1.2}
            />
          )
        }
        className={clsx(
          props.underlined && props.variant === 'text' ? 'underlined' : '',
          props.className,
          dense ? 'dense' : '',
        )}
      >
        {props.children ?? props.label}
      </MuiButton>
    );
  },
);

Button.displayName = 'Button';

export default Button;
